$(document).ready(function() {
  if (navigator.platform === 'iPhone') {
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  }
  
    // Mobile navigation
//   $(".facet-link").on("click", function () {
//     var filter = $(this).attr("data-filter")

//     $(".facet-section").css("display", "none")
//     $(filter).css("display", "flex")

    
//     $(".facet-link").removeClass("active")
//     $(this).addClass("active")
//   })


  // Mobile navigation
  $(".mobile-nav .primary-link").on("click", function () {
    var filter = $(this).attr("data-filter")

    $(".mobile-navigation-inner").hide()
    $(filter).show()

    $(".mobile-nav .primary-link").removeClass("active")
    $(this).addClass("active")
  })

  // Login page
  $(".show-login").on("click", function () {
    $("#customer-recover").addClass("form-hidden")
    $("#customer-login").removeClass("form-hidden")

    return false
  })

  $(".show-recover-password").on("click", function () {
    $("#customer-recover").removeClass("form-hidden")
    $("#customer-login").addClass("form-hidden")

    return false
  })

  
  $(".special-instructions__heading").on("click", function () {
    if ($(".special-instructions__wrapper").is(":visible")) {
        $(".special-instructions__wrapper").slideUp()
        $(this).removeClass("open")
    } else {
      $(".special-instructions__wrapper").slideDown()
       $(this).addClass("open")
    }
  })


  // Add to Cart Form
  let
    addToCartFormSelector = '.add-to-cart-form',
    productOptionSelector = addToCartFormSelector + ' [name*=option]';

  let productForm = {
    onProductOptionChanged: function(event) {
      let
        $form = $(this).closest(addToCartFormSelector),
        selectedVariant = productForm.getActiveVariant($form);

      $form.trigger('form:change', [selectedVariant]);
    },
    getActiveVariant: function($form) {
      let
        variants = JSON.parse(decodeURIComponent($form.attr('data-variants'))),
        formData = $form.serializeArray(),
        formOptions = {
          option1: null,
          option2: null,
          option3: null
        },
        selectedVariant = null;

      $.each(formData, function(index, item) {
        if (item.name.indexOf('option') !== -1) {
          formOptions[item.name] = item.value;
        }
      });

      $.each(variants, function(index, variant) {
        if (variant.option1 === formOptions.option1 && variant.option2 === formOptions.option2 && variant.option3 === formOptions.option3) {
          selectedVariant = variant;
          return false;
        }
      });

      return selectedVariant;

    },
    validate: function(event, selectedVariant) {
      let
        $form = $(this),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.inventory_quantity > 0,
        $id = $form.find('.js-variant-id'),
        $addToCartButton = $form.find('#add-to-cart-button'),
        $price = $('.js-price'),
        variantPrice,
        compareAtPrice,
        formattedVariantPrice,
        formattedVariantCompareAtPrice,
        unit,
        priceHtml;

      if (hasVariant) {
        variantPrice = selectedVariant.price/100;
        compareAtPrice = selectedVariant.compare_at_price/100;

        formattedVariantPrice = '$' + variantPrice;
        formattedVariantCompareAtPrice = '$' + compareAtPrice;

        unit = $price.attr('data-unit')

        console.log(formattedVariantPrice)
        console.log(formattedVariantCompareAtPrice)

        if (variantPrice < compareAtPrice) {
          priceHtml = '<span class="price-compare-at">'+formattedVariantCompareAtPrice+'</span> <span class="price-highlight">'+formattedVariantPrice+'</span><span class="price-highlight"> ' + unit + '</span>'
        } else {
          priceHtml = '<span class="money">'+formattedVariantPrice+'</span><span> ' + unit + '</span>';
        }

        window.history.replaceState(null, null, '?variant='+selectedVariant.id);
      }
      else {
        priceHtml = $price.attr('data-default-price');
      }

      if (canAddToCart) {
        $id.val(selectedVariant.id);
        $addToCartButton.prop('disabled', false);
        $addToCartButton.text('Add to cart');
      }
      else {
        $id.val('');
        $addToCartButton.prop('disabled', true);
        $addToCartButton.text('Sold out');
      }

      $price.html(priceHtml);
    },
    init: function() {
      $(document).on('change', productOptionSelector, productForm.onProductOptionChanged);
      $(document).on('form:change', addToCartFormSelector, productForm.validate);
    }
  };

  productForm.init();

  // Ajax API Functionality
  let miniCartContentsSelector = '.js-mini-cart-contents';
  let ajaxify = {
    onQuantityButtonClick: function(event) {
      // alert('button clicked');
      let
        $button = $(this),
        $form = $button.closest('form'),
        $quantity = $form.find('.js-ing-quantity-field'),
        quantityValue = parseInt($quantity.val()),
        max = $quantity.attr('max') ? parseInt($quantity.attr('max')) : null;
      if ($button.hasClass('plus') && (max === null || quantityValue+1 <= max)) {
        // do something for plus click
        $quantity.val(quantityValue + 1).change();
        console.log("added 1")
      }
      else if ($button.hasClass('minus')) {
        // do something for minus click
        $quantity.val(quantityValue - 1).change();
      }
    },
    onQuantityFieldChange: function(event) {
      let
        $field = $(this),
        $form = $field.closest('form'),
        $quantityText = $form.find('.js-ing-quantity-text'),
        shouldDisableMinus = parseInt(this.value) === 1,
        shouldDisablePlus = parseInt(this.value) === parseInt($field.attr('max')),
        $minusButton = $form.find('.js-ing-quantity-button.minus'),
        $plusButton = $form.find('.js-ing-quantity-button.plus');
      $quantityText.text(this.value);
      if (shouldDisableMinus) {
        $minusButton.prop('disabled', true);
      }
      else if ($minusButton.prop('disabled') === true) {
        $minusButton.prop('disabled', false);
      }
      if (shouldDisablePlus) {
        $plusButton.prop('disabled', true);
      }
      else if ($plusButton.prop('disabled') === true) {
        $plusButton.prop('disabled', false);
      }
    },
    onAddToCart: function(event) {
      event.preventDefault();

      $.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: $(this).serialize(),
        dataType: 'json',
        success: ajaxify.onCartUpdated,
        error: ajaxify.onError
      });
    },
    onCartUpdated: function() {
      let
        $miniCartFieldset = $(miniCartContentsSelector + ' .js-cart-fieldset');

//       $miniCartFieldset.prop('disabled', true);

      $.ajax({
        type: 'GET',
        url: '/cart',
        context: document.body,
        success: function(context) {
          let
            $dataCartContents = $(context).find('.js-cart-page-contents'),
            dataCartHtml = $dataCartContents.html(),
            dataCartItemCount = $dataCartContents.attr('data-cart-item-count'),
            $miniCartContents = $(miniCartContentsSelector),
            $cartItemCount = $('.js-cart-item-count');

          $cartItemCount.text(dataCartItemCount);
          $miniCartContents.html(dataCartHtml);

          if (parseInt(dataCartItemCount) > 0) {
            ajaxify.openCart();
          }
          else {
            ajaxify.closeCart();
          }
        }
      });
    },
    onError: function(XMLHttpRequest, textStatus) {
      let data = XMLHttpRequest.responseJSON;
      alert(data.status + ' - ' + data.message + ': ' + data.description);
    },
    onCartButtonClick: function(event) {
      let
        isCartOpen = $('html').hasClass('mini-cart-open'),
        isInCart = window.location.href.indexOf('/cart') !== -1;

      if (!isInCart) {
        event.preventDefault();
        if (!isCartOpen) {
          ajaxify.openCart();
        }
        else {
          ajaxify.closeCart();
        }
      }
    },
    openCart: function() {
      $('html').addClass('mini-cart-open');
    },
    closeCart: function() {
      $('html').removeClass('mini-cart-open');
    },
    init: function() {
      $(document).on('submit', addToCartFormSelector, ajaxify.onAddToCart);

      $(document).on('click', '.js-cart-link, .js-keep-shopping', ajaxify.onCartButtonClick);

      $(document).on('click', '.js-ing-quantity-button', ajaxify.onQuantityButtonClick);

      $(document).on('change', '.js-ing-quantity-field', ajaxify.onQuantityFieldChange);

      $(document).on('click', '.cart-close, html.mini-cart-open .overlay', ajaxify.closeCart)
    }
  };

  ajaxify.init();


  // Quantity Fields
  let
    quantityFieldSelector = '.js-quantity-field',
    quantityButtonSelector = '.js-quantity-button',
    quantityPickerSelector = '.js-quantity-picker',
    quantityPicker = {
      onButtonClick: function(event) {
        // alert('button clicked');
        let
          $button = $(this),
          $picker = $button.closest(quantityPickerSelector),
          $quantity = $picker.find('.js-quantity-field'),
          quantityValue = parseInt($quantity.val()),
          max = $quantity.attr('max') ? parseInt($quantity.attr('max')) : null;

        if ($button.hasClass('plus') && (max === null || quantityValue+1 <= max)) {
          // do something for plus click
          $quantity.val(quantityValue + 1).change();
        }
        else if ($button.hasClass('minus')) {
          // do something for minus click
          $quantity.val(quantityValue - 1).change();
        }
      },
      onChange: function(event) {
        let
          $field = $(this),
          $picker = $field.closest(quantityPickerSelector),
          $quantityText = $picker.find('.js-quantity-text'),
          shouldDisableMinus = parseInt(this.value) === parseInt($field.attr('min')),
          shouldDisablePlus = parseInt(this.value) === parseInt($field.attr('max')),
          $minusButton = $picker.find('.js-quantity-button.minus'),
          $plusButton = $picker.find('.js-quantity-button.plus');

        $quantityText.text(this.value);

        if (shouldDisableMinus) {
          $minusButton.prop('disabled', true);
        }
        else if ($minusButton.prop('disabled') === true) {
          $minusButton.prop('disabled', false);
        }

        if (shouldDisablePlus) {
          $plusButton.prop('disabled', true);
        }
        else if ($plusButton.prop('disabled') === true) {
          $plusButton.prop('disabled', false);
        }
      },
      init: function() {
        $(document).on('click', quantityButtonSelector, quantityPicker.onButtonClick);
        $(document).on('change', quantityFieldSelector, quantityPicker.onChange);
      }
    };

  quantityPicker.init()



  // Line Item
  let
    removeLineSelector = '.js-remove-line',
    lineQuantitySelector = '.js-line-quantity';

  let lineItem = {
    isInMiniCart: function(element) {
      let
        $element = $(element),
        $miniCart = $element.closest(miniCartContentsSelector),
        isInMiniCart = $miniCart.length !== 0;

      return isInMiniCart;
    },
    onLineQuantityChanged: function(event) {
      let
        quantity = this.value,
        id = $(this).attr('id').replace('updates_', ''),
        changes = {
          quantity: quantity,
          id: id
        },
        isInMiniCart = lineItem.isInMiniCart(this);

      if (isInMiniCart) {
        $.post('/cart/change.js', changes, ajaxify.onCartUpdated, 'json');
      }
    },
    onLineRemoved: function(event) {
      let isInMiniCart = lineItem.isInMiniCart(this);

      if (isInMiniCart) {
        event.preventDefault();
        
        let
          $removeLink = $(this),
          removeQuery = $removeLink.attr('href').split('change?')[1];
        $.post('/cart/change.js', removeQuery, ajaxify.onCartUpdated, 'json');
      }
    },
    init: function() {
      $(document).on('click', removeLineSelector, lineItem.onLineRemoved);
      $(document).on('change', lineQuantitySelector, lineItem.onLineQuantityChanged);
    }
  };

  lineItem.init();


  
  // Search Input
  let
    searchInputSelector = '.js-search-input',
    searchSubmitSelector = '.js-search-submit',
    onSearchInputKeyup = function(event) {
      let
        $form = $(this).closest('form'),
        $button = $form.find(searchSubmitSelector),
        shouldDisableButton = this.value.length === 0;

      $button.prop('disabled', shouldDisableButton);

    };

    $(document).on('keyup', searchInputSelector, onSearchInputKeyup);
  
});


// 1st carousel, main
const carouselSlides = document.querySelectorAll(".carousel a");

if (carouselSlides) {
  if (carouselSlides.length > 2) {
    $('.carousel').flickity({
      resize: 'false',
      cellAlign: 'left',
      wrapAround: true,
      contain: true,
      prevNextButtons: true,
      pageDots: false,
      lazyLoad: true,
      autoPlay: 2000,
      watchCSS: true
    });
  } else {
    $('.carousel').flickity({
      resize: 'false',
      cellAlign: 'left',
      wrapAround: true,
      contain: true,
      prevNextButtons: false,
      pageDots: false,
      lazyLoad: true,
      watchCSS: true,
      draggable: false
    });
  }
}

// main slider
$('.main-slider').flickity({
  // options
  cellAlign: 'left',
  contain: true,
  adaptiveHeight: true
});


// Featured blog
var featuredBlog = document.querySelector('.featured-blog .article-list');

if (featuredBlog) {
  var flkty = new Flickity(featuredBlog, {
    resize: 'false',
    cellAlign: 'left',
    wrapAround: true,
    contain: true,
    prevNextButtons: true,
    pageDots: false,
    lazyLoad: true,
    autoPlay: 4000
  });

  flkty.on('settle', function (index) {
    if (flkty.resizeQueued) {
      flkty.resizeQueued = false;
      flkty.onresize();
    }
  }); 

  window.addEventListener('resize', function () {
    if (flkty.isAnimating) {
      flkty.resizeQueued = true;
    } else {
      flkty.onresize();
    }
  });
  }

// Dine locations
var locationCarousel = document.querySelector('.dine__location-list');

if (locationCarousel) {
  var loc = new Flickity(locationCarousel, {
    resize: 'false',
    cellAlign: 'left',
    wrapAround: true,
    contain: true,
    prevNextButtons: true,
    pageDots: false,
    lazyLoad: true,
    autoPlay: 4000
  });


  loc.on('settle', function (index) {
    if (loc.resizeQueued) {
      loc.resizeQueued = false;
      loc.onresize();
    }
  }); 

  window.addEventListener('resize', function () {
    if (loc.isAnimating) {
      loc.resizeQueued = true;
    } else {
      loc.onresize();
    }
  });
}

// Calculate the header height to set the margin top for the hero area & mobile navigation
const htmlTag = document.querySelector("html")

const announcementBar = document.querySelector("#shopify-section-announcement-bar")
const header = document.querySelector("#shopify-section-header")
const heroTag = document.querySelector(".hero")

// Hamburger navigation
const toggleNav = document.querySelector(".toggle-nav")
const hamburger = document.querySelector(".hamburger")

const mobileMenu = document.querySelector(".mobile-nav");
const searchElement = document.querySelector(".search")

if (toggleNav) {
  toggleNav.addEventListener("click", function (event) {
    hamburger.classList.toggle("animate")
    htmlTag.classList.toggle("menu-open")
  })
}



// Add shadow to the header
const fadeBoxShadow = function () {
  const pixels = window.pageYOffset
  const weighting = 1000

  const alphaBox = Math.min(0.5, pixels / weighting)
  
  header.style.boxShadow = `0 0 4px rgba(0,0,0,${alphaBox})`
}

if (header) {
  fadeBoxShadow()

  document.addEventListener("scroll", function () {
    fadeBoxShadow()
  })
}
// Set the hero's negative margin & the top position of the mobile menu based on the header + announcement bar height
const updateMobileMenu = function () {
  const announcementBarHeight = announcementBar.offsetHeight
  const headerHeight = header.offsetHeight

  const pixels = window.pageYOffset

  if (pixels > announcementBarHeight) {
    mobileMenu.style.top = headerHeight + "px"
    mobileMenu.style.minHeight = `calc(100vh - ${headerHeight}px)`

    searchElement.style.top = headerHeight + "px"

    if (window.innerWidth < 960) {
      searchElement.style.minHeight = `calc(100vh - ${headerHeight}px)`
    }
  } else {
    mobileMenu.style.top = announcementBarHeight + headerHeight + "px"
    mobileMenu.style.minHeight = `calc(100vh - ${announcementBarHeight}px - ${headerHeight}px)`

    searchElement.style.top = announcementBarHeight + headerHeight + "px"

    if (window.innerWidth < 960) {
      searchElement.style.minHeight = `calc(100vh - ${announcementBarHeight}px - ${headerHeight}px)`
    }
  }
}

if (header) {
  updateMobileMenu()

  window.addEventListener("resize", function () {
    updateMobileMenu()
  })

  document.addEventListener("scroll", function () {
    updateMobileMenu()
  })
}

// Show & hide search
const searchIcons = document.querySelectorAll(".search-store")
const closeSearch = document.querySelector(".close-search")

const showSearch = function () {
  if (searchElement.classList.contains("open")) {
    searchElement.classList.remove("open")
  } else {
    searchElement.classList.add("open")
  }
}

if (closeSearch) {
  closeSearch.addEventListener("click", function () {
    showSearch();
  })
}

searchIcons.forEach(searchIcon => {
  searchIcon.addEventListener("click", function () {
    showSearch();
  })
})

// Smooth scroll
const scrollLinks = document.querySelectorAll('.js-scroll')

scrollLinks.forEach(link => {
  link.addEventListener('click', (event) => {
    event.preventDefault()
    const href = link.getAttribute('href')
    
    document.querySelector(href).scrollIntoView({
      behavior: 'smooth'
    })
  })
})
